/// <amd-module name="Feed/Legacy/Actions/FeedSettings/ChangeSelectedUpstreamSourcesHandler" />
import { IFeedSettingsState } from "Feed/Legacy/Components/Settings/IFeedSettingsState";
import { UpstreamSource } from "Feed/Common/Contracts/Feed";

export class ChangeSelectedUpstreamSourcesHandler {
    public static handle(state: IFeedSettingsState, upstreamSources: UpstreamSource[]): void {
        state.selectedUpstreamSources = upstreamSources;
    }
}
